import { render, staticRenderFns } from "./GestaoProgramaDashboard.vue?vue&type=template&id=b29b3766&"
import script from "./GestaoProgramaDashboard.vue?vue&type=script&lang=js&"
export * from "./GestaoProgramaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GestaoProgramaDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VRow,VTooltip})
